import { Component, Input, OnInit } from '@angular/core';
import { BrowseConfig } from '@core/bean/browse-config';
import { Pagination } from '@core/bean/pagination';
import { CommonsService } from '@core/service/commons.service';
import { NzModalService } from 'ng-zorro-antd';
import { MaterialInfoListService } from '../../../../routes/jy-srm/purchase/material-info/material-info-list/material-info.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Sort } from '@core/bean/sort';
import { Direction } from '@core/bean/direction';

@Component({
  selector: 'material-browse',
  templateUrl: './material.browse.component.html',
  styles: []
})
export class MaterialBrowseComponent implements OnInit {

  static componentName = 'MaterialBrowseComponent';

  @Input() config:BrowseConfig;
  @Input() onOk:(data:any | [any]) => void;
  @Input() onCancel:() => void;

  visible = false;
  formLoading = false;
  pagination:Pagination = new Pagination();
  searchData:any = {};
  constructor(private commonsService:CommonsService,
              private modalService:NzModalService,
              private materialService:MaterialInfoListService) {
    this.pagination.getData = function (params:HttpParams):Observable<any> {
      return materialService.query(params);
    }
  }


  ngOnInit() {
    if (!this.config.multiple) {
      this.pagination.multipleCheck = false;
    }
    this.searchData = this.config.searchData;
    this.getData();
    this.visible = true;
  }

  getData() {
    this.pagination.searchData = this.searchData;
    this.pagination.searchData['delete'] = false;
    if(this.searchData['matCode']){
      this.searchData['matCode'] = this.searchData['matCode'].trim();
    }
    this.pagination.addDefaultSort(new Sort('createdDate', Direction.DESC));
    this.pagination.toFirstPage();
  }

  modalOk() {
    let result = this.pagination.selectedRows;
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }

  modalCancel() {
    this.visible = false;
    this.onCancel();
  }

  selectData(data){
    let result = [data];
    if (!this.config.multiple) {
      result = result.length > 0 ? result[0] : null;
      if (result) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    } else {
      if (result.length > 0) {
        this.onOk(result);
        this.visible = false;
      } else {
        this.commonsService.showWarningMessage("commons.info.selectData");
      }
    }
  }
}
